/* eslint-disable @typescript-eslint/naming-convention */
import { PaletteOptions } from '@material-ui/core/styles/createPalette';

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    color: typeof Color;
  }

  interface PaletteOptions {
    color: typeof Color;
  }
}

export enum Color {
  DodgerBlue = '#4687FF',
  ScienceBlue = '#0A54DC',
  Malibu = '#8EB6FF',
  Cloudless = '#D3E3FF',
  IcyLilac = '#E5EDFB',
  MexicanRed = '#BF1D32',
  WildWatermelon = '#F64F64',
  SweetPink = '#FD8695',
  PalePink = '#FFD9DE',
  JewelGreen = '#0C9A38',
  LimeGreen = '#27BE56',
  GrannyApple = '#CAF0D5',
  ScandalGreen = '#E1FCE8',
  Persimmon = '#E35E00',
  Pumpkin = '#FF7E23',
  PeachPuff = '#FFDFC9',
  Seashell = '#FFF1E8',
  ArsenicGray = '#363B47',
  Quarzo = '#C9D0D9',
  Mystic = '#DDE3EA',
  AthensGray = '#E9EBEE',
  Woodsmoke = '#171A20',
  Shark = '#1C1F26',
  Porcelain = '#F5F6F8',
  Tuna = '#373B42',
  PaleSky = '#687183',
  EchoGray = '#9FA8B8',
  White = '#FFFFFF',
  Black = '#000000',
  LightBlue = '#F2FFFF',
  LightGrey = '#E1E1E9',
  DarkBlue = '#000027',
  LighterDarkBlue = '#0D0D32',
  LightDarkBlue = '#494C68',
  BrightGreen = '#B1EB21',
  VeryLightGrey = '#FAFAFF',
  MediumLightBlue = '#7F8699',
  WhiteSmoke = '#F8F8F8',
  Razzmatazz = '#F50057',
}

interface ICustomPaletteOptions extends PaletteOptions {
  color: typeof Color;
}

export const palette: ICustomPaletteOptions = <const>{
  color: { ...Color },
  primary: {
    light: Color.Malibu,
    main: Color.DodgerBlue,
    dark: Color.ScienceBlue,
    contrastText: Color.White,
  },
  secondary: {
    main: Color.Razzmatazz,
    light: Color.WhiteSmoke,
  },
  error: {
    light: Color.PalePink,
    main: Color.WildWatermelon,
    dark: Color.MexicanRed,
    contrastText: Color.White,
  },
  warning: {
    light: Color.PeachPuff,
    main: Color.Pumpkin,
    dark: Color.Persimmon,
    contrastText: Color.White,
  },
  info: {
    light: Color.IcyLilac,
    main: Color.DodgerBlue,
    dark: Color.ScienceBlue,
    contrastText: Color.White,
  },
  success: {
    light: Color.GrannyApple,
    main: Color.LimeGreen,
    dark: Color.JewelGreen,
    contrastText: Color.White,
  },
  common: {
    white: Color.White,
    black: Color.Black,
  },
  text: {
    primary: Color.Tuna,
    secondary: Color.PaleSky,
    disabled: Color.EchoGray,
    hint: Color.EchoGray,
  },
  divider: Color.AthensGray,
  background: {
    default: Color.Shark,
  },
};
